// 1. FIXED PollComponent - Replace your current one
import React, { useState, useEffect } from 'react';
// utils/hashtagUtils.js
export const extractHashtags = (text) => {
  if (!text) return [];
  const regex = /#([a-zA-Z0-9_]+)/g;
  const matches = [...text.matchAll(regex)];
  return matches.map(match => match[1].toLowerCase());
};

export const formatContentWithHashtags = (content, onHashtagClick) => {
  if (!content) return content;
  
  const parts = content.split(/(#[a-zA-Z0-9_]+)/g);
  
  return parts.map((part, index) => {
    if (part.startsWith('#')) {
      const tag = part.slice(1);
      return (
        <span
          key={index}
          className="hashtag"
          style={{
            color: '#8b5cf6',
            fontWeight: '600',
            cursor: 'pointer',
            textDecoration: 'none',
            transition: 'all 0.2s ease'
          }}
          onClick={(e) => {
            e.stopPropagation();
            onHashtagClick?.(tag);
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = '#7c3aed';
            e.currentTarget.style.textDecoration = 'underline';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = '#8b5cf6';
            e.currentTarget.style.textDecoration = 'none';
          }}
        >
          {part}
        </span>
      );
    }
    return part;
  });
};
